// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__32Sxe","description":"PatientConsentPreview_description__22Tcw"};